/* ==========================================================================
   Apparel with print — garment picker, print positions, artwork, cart.

   Two lines go into the cart: the garment, and the Print Application add-on
   at one unit per printed position. Quantity multiplies, so three shirts with
   a front logo and a back print is six applications. Both lines carry the same
   _print_group so the cart can keep them together.

   Files ride on the print line as line-item properties, which is why the add
   is done with FormData rather than the JSON form of /cart/add.js — the JSON
   endpoint cannot carry a file.
   ========================================================================== */

(function () {
  'use strict';

  var cfg = window.APConfig;
  var form = document.getElementById('APForm');
  if (!cfg || !form) return;

  var $ = function (id) { return document.getElementById(id); };
  var MAX_BYTES = (cfg.maxFileMb || 5) * 1024 * 1024;

  var state = {
    variant: null,
    qty: 1,
    places: [],           // [{key, label}]
    art: {}               // key -> {file: File|null, link: string}
  };

  /* ── money ───────────────────────────────────────────────────────────── */

  function money(cents) {
    var v = (cents / 100).toFixed(2).split('.');
    v[0] = v[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return 'R ' + v.join('.');
  }

  /* ── garment options ─────────────────────────────────────────────────── */

  function chosenOptions() {
    var out = [];
    for (var i = 1; i <= cfg.optionCount; i++) {
      var el = form.querySelector('input[name="option' + i + '"]:checked');
      out.push(el ? el.value : null);
    }
    return out;
  }

  function resolveVariant() {
    var opts = chosenOptions();
    state.variant = cfg.variants.find(function (v) {
      return opts.every(function (val, i) { return val === null || v['option' + (i + 1)] === val; });
    }) || null;
  }

  function paintOptions() {
    var opts = chosenOptions();
    form.querySelectorAll('.ap__chip').forEach(function (chip) {
      var input = chip.querySelector('input');
      chip.classList.toggle('is-selected', input.checked);
    });
    form.querySelectorAll('[data-chosen-for]').forEach(function (el) {
      var i = parseInt(el.getAttribute('data-chosen-for'), 10);
      el.textContent = opts[i - 1] ? ' · ' + opts[i - 1] : '';
    });
    var sold = $('APSoldOut');
    if (sold) sold.hidden = !(state.variant && !state.variant.available);
  }

  /* ── artwork blocks, one per chosen position ─────────────────────────── */

  function renderArtBlocks() {
    var step = $('APArtStep');
    var host = $('APArtBlocks');
    if (!step || !host) return;

    step.hidden = state.places.length === 0;

    // Keep existing blocks so a chosen file survives ticking another position.
    var wanted = state.places.map(function (p) { return p.key; });
    Array.prototype.slice.call(host.children).forEach(function (child) {
      if (wanted.indexOf(child.getAttribute('data-art-for')) === -1) {
        delete state.art[child.getAttribute('data-art-for')];
        child.remove();
      }
    });

    state.places.forEach(function (p) {
      if (host.querySelector('[data-art-for="' + p.key + '"]')) return;
      if (!state.art[p.key]) state.art[p.key] = { file: null, link: '' };

      var block = document.createElement('div');
      block.className = 'ap__art';
      block.setAttribute('data-art-for', p.key);
      block.innerHTML =
        '<p class="ap__art-title">' + p.label + '</p>' +
        '<div class="ap__drop">' +
        '  <input type="file" accept=".png,.jpg,.jpeg,.pdf,.svg,.ai,.eps,.psd">' +
        '  <div class="ap__drop-body">' +
        '    <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#1565C0" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 16V4M12 4 7 9M12 4l5 5"/><path d="M4 15v3a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-3"/></svg>' +
        '    <span>Drop a file or click to choose</span>' +
        '  </div>' +
        '  <div class="ap__drop-done" hidden><span class="ap__drop-name"></span><button type="button" class="ap__drop-clear">Remove</button></div>' +
        '</div>' +
        '<details class="ap__link"><summary>Over ' + cfg.maxFileMb + ' MB? Paste a link instead</summary>' +
        '<input type="text" class="ap__link-input" placeholder="https://drive.google.com/file/..." autocomplete="off"></details>';

      host.appendChild(block);

      var fileInput = block.querySelector('input[type=file]');
      var body = block.querySelector('.ap__drop-body');
      var done = block.querySelector('.ap__drop-done');
      var nameEl = block.querySelector('.ap__drop-name');
      var drop = block.querySelector('.ap__drop');

      function accept(file) {
        if (!file) return;
        if (file.size > MAX_BYTES) {
          fileInput.value = '';
          alert('That file is over ' + cfg.maxFileMb + ' MB. Paste a shareable link instead.');
          block.querySelector('.ap__link').open = true;
          return;
        }
        state.art[p.key].file = file;
        nameEl.textContent = file.name + ' (' + (file.size / 1024 / 1024).toFixed(1) + ' MB)';
        body.hidden = true;
        done.hidden = false;
        hideError();
      }

      fileInput.addEventListener('change', function () { accept(this.files[0]); });
      drop.addEventListener('dragover', function (e) { e.preventDefault(); drop.classList.add('is-over'); });
      drop.addEventListener('dragleave', function () { drop.classList.remove('is-over'); });
      drop.addEventListener('drop', function (e) {
        e.preventDefault();
        drop.classList.remove('is-over');
        if (!e.dataTransfer.files.length) return;
        try {
          var dt = new DataTransfer();
          dt.items.add(e.dataTransfer.files[0]);
          fileInput.files = dt.files;
        } catch (err) { /* older browsers: the click path still works */ }
        accept(e.dataTransfer.files[0]);
      });
      block.querySelector('.ap__drop-clear').addEventListener('click', function () {
        fileInput.value = '';
        state.art[p.key].file = null;
        body.hidden = false;
        done.hidden = true;
      });
      block.querySelector('.ap__link-input').addEventListener('input', function () {
        state.art[p.key].link = this.value.trim();
        hideError();
      });
    });
  }

  function hideError() {
    var e = $('APArtError'); if (e) e.hidden = true;
  }

  /* ── totals ──────────────────────────────────────────────────────────── */

  function render() {
    resolveVariant();
    paintOptions();
    renderArtBlocks();

    var garment = state.variant ? state.variant.price : 0;
    var prints = state.places.length;
    var printUnits = prints * state.qty;
    var garmentTotal = garment * state.qty;
    /* Sum each position at ITS price rather than multiplying one price by the
       count — a front at R45 and a pocket logo at R15 is R60 a garment, not
       two of whichever price happened to be first. */
    var printPerGarment = state.places.reduce(function (n, pl) { return n + pl.addonPrice; }, 0);
    var printTotal = printPerGarment * state.qty;

    var unit = $('APUnitPrice');
    if (unit) unit.textContent = money(garment);
    var note = $('APPriceNote');
    if (note) note.textContent = prints ? 'garment, before printing' : 'garment — printing added below';

    var bd = $('APBreakdown');
    if (bd) {
      var rows =
        '<div><dt>' + cfg.productTitle + ' × ' + state.qty + '</dt><dd>' + money(garmentTotal) + '</dd></div>';
      if (prints) {
        rows +=
          '<div><dt>Printing — ' + state.places.map(function (p) { return p.label; }).join(', ') +
          '<span class="ap__bd-note">' + prints + ' position' + (prints > 1 ? 's' : '') +
          ' × ' + state.qty + ' garment' + (state.qty > 1 ? 's' : '') + ' = ' + money(printPerGarment) + ' each' +
          '</span></dt><dd>' + money(printTotal) + '</dd></div>';
      } else {
        rows += '<div class="ap__bd-pending"><dt>Printing</dt><dd>choose a position</dd></div>';
      }
      bd.innerHTML = rows;
    }

    var total = $('APTotal');
    if (total) total.textContent = money(garmentTotal + printTotal);

    var add = $('APAdd');
    if (add) add.disabled = !state.variant || !state.variant.available || !cfg.addonVariantId;
  }

  /* ── events ──────────────────────────────────────────────────────────── */

  form.addEventListener('change', function (e) {
    if (e.target.matches('input[type=radio][data-option-index]')) { render(); return; }
    if (e.target.matches('.ap__place-input')) {
      var boxes = Array.prototype.slice.call(form.querySelectorAll('.ap__place-input:checked'));
      /* Each position carries its own add-on variant and price, so a tee can
         charge R45 for a full front and R15 for a pocket logo on one page.
         Falls back to the product-level add-on when a position names none. */
      state.places = boxes.map(function (b) {
        return {
          key: b.getAttribute('data-place'),
          label: b.value,
          addonId: b.getAttribute('data-addon-id') || cfg.addonVariantId,
          addonPrice: Number(b.getAttribute('data-addon-price') || cfg.addonPrice)
        };
      });
      form.querySelectorAll('.ap__place').forEach(function (l) {
        l.classList.toggle('is-selected', l.querySelector('.ap__place-input').checked);
      });
      var pe = $('APPlaceError'); if (pe) pe.hidden = true;
      render();
    }
  });

  var qtyInput = $('APQty');
  $('APDown').addEventListener('click', function () { state.qty = Math.max(1, state.qty - 1); qtyInput.value = state.qty; render(); });
  $('APUp').addEventListener('click', function () { state.qty += 1; qtyInput.value = state.qty; render(); });
  qtyInput.addEventListener('input', function () {
    var n = parseInt(this.value, 10);
    state.qty = isNaN(n) || n < 1 ? 1 : n;
    render();
  });
  qtyInput.addEventListener('blur', function () { this.value = state.qty; });

  document.querySelectorAll('[data-ap-thumb]').forEach(function (t) {
    t.addEventListener('click', function () {
      var main = $('APImage');
      if (main) { main.src = this.getAttribute('data-ap-thumb'); main.removeAttribute('srcset'); }
      document.querySelectorAll('[data-ap-thumb]').forEach(function (o) { o.classList.remove('is-active'); });
      this.classList.add('is-active');
    });
  });

  /* ── add to cart ─────────────────────────────────────────────────────── */

  form.addEventListener('submit', function (e) {
    e.preventDefault();

    /* On a garment that also sells plain, choosing nothing is a complete
       order rather than an incomplete one — the shirt goes in the basket on its
       own and no print line is added at all. The tees stay as they were: they
       are only sold printed, so an empty choice is still an error there. */
    if (!state.places.length && !cfg.printOptional) {
      var err = $('APPlaceError');
      if (err) { err.hidden = false; err.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      return;
    }
    var missing = state.places.filter(function (p) {
      var a = state.art[p.key] || {};
      return !a.file && !a.link;
    });
    if (missing.length) {
      $('APArtError').hidden = false;
      $('APArtError').textContent =
        'Please add artwork for: ' + missing.map(function (m) { return m.label; }).join(', ') + '.';
      $('APArtError').scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    if (!state.variant) return;

    addToCart();
  });

  function addToCart() {
    var btn = $('APAdd');
    var err = $('APCartError');
    btn.disabled = true;
    btn.textContent = 'Adding…';
    err.hidden = true;

    // Ties the garment line to its printing line so the cart can treat them
    // as one thing. Leading underscore keeps it off the customer's invoice.
    var group = 'ap-' + Date.now().toString(36);
    var notes = $('ap-notes').value.trim();

    var garmentBody = new FormData();
    garmentBody.append('id', state.variant.id);
    garmentBody.append('quantity', state.qty);
    garmentBody.append('properties[Print]', state.places.map(function (p) { return p.label; }).join(', '));
    garmentBody.append('properties[_print_group]', group);

    fetch('/cart/add.js', { method: 'POST', body: garmentBody })
      .then(check)
      .then(function () {
        /* Nothing chosen means no add-on line. Adding one at quantity zero
           would either be rejected or, worse, accepted as a free line. */
        if (!state.places.length) return;
        /* Positions can sit on different add-on products at different prices,
           so they group by add-on: one cart line per distinct price, each at
           its own quantity. A single line at one price would silently charge
           pocket-logo money for a full front, or the other way about. */
        var byAddon = {};
        state.places.forEach(function (pl) {
          (byAddon[pl.addonId] = byAddon[pl.addonId] || []).push(pl);
        });

        var addonIds = Object.keys(byAddon);
        return addonIds.reduce(function (chain, addonId) {
          return chain.then(function () {
            var group2 = byAddon[addonId];
            var printBody = new FormData();
            printBody.append('id', addonId);
            printBody.append('quantity', group2.length * state.qty);
            printBody.append('properties[For]', cfg.productTitle + ' — ' + state.variant.title);
            printBody.append('properties[Positions]', group2.map(function (p) { return p.label; }).join(', '));
            group2.forEach(function (p) {
              var a = state.art[p.key] || {};
              if (a.file) printBody.append('properties[' + p.label + ' artwork]', a.file, a.file.name);
              else if (a.link) printBody.append('properties[' + p.label + ' artwork]', a.link);
            });
            if (notes) printBody.append('properties[Notes]', notes);
            printBody.append('properties[_print_group]', group);
            return fetch('/cart/add.js', { method: 'POST', body: printBody }).then(check);
          });
        }, Promise.resolve());
      })
      .then(function () { window.location.href = '/cart'; })
      .catch(function (msg) {
        btn.disabled = false;
        btn.textContent = 'Add to cart';
        err.hidden = false;
        err.textContent = msg && msg.message ? msg.message : 'Could not add that to the cart. Please try again.';
      });
  }

  function check(res) {
    if (res.ok) return res.json();
    return res.json()
      .catch(function () { throw new Error('Could not add that to the cart. Please try again.'); })
      .then(function (j) { throw new Error(j.description || j.message || 'Could not add that to the cart.'); });
  }

  /* ── link help modal, shared with the DTF screen ─────────────────────── */

  var helpModal = $('dtf-link-help-modal');
  if (helpModal) {
    document.addEventListener('click', function (e) {
      if (e.target.closest('.ap__link summary')) return;
      if (e.target.id === 'dtf-help-close' || e.target.id === 'dtf-help-overlay') {
        helpModal.hidden = true;
        document.body.style.overflow = '';
      }
    });
  }

  render();
})();
